// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2eSBP","inputWrap":"styles_inputWrap__36eZO","input":"styles_input__2T33a"};